import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Toast } from "../../../../components";
import { addAddress, editAddress } from "../../../../redux/cart/CartServices";
import { useSelector, useDispatch } from "react-redux";
import ArrowDown from "../../../../assets/images/arrowDown.svg";
import CheckboxOn from "../../../../assets/images/CheckboxOn.svg";
import CheckboxOff from "../../../../assets/images/CheckboxOff.svg";
import Imagebrand from "../../../../assets/images/imag.svg";
import axios from "axios";
import DropDown from "../../../../components/Select";
import { areaValue, cityValue, clearTest } from "../../../../redux/auth/actions";
// import { getDeliveryAddress } from "../../../../redux/cart/CartAction";
import { getDeliveryAddress } from "../../../../redux/savedaddress/SavedAddressAction";

import "../../styles.scss";
import { Row, Col, Form } from "react-bootstrap";
import useWindowSize from "./../../../../hooks/useWindowSize";
import Multiselect from "multiselect-react-dropdown";
import Closeicon from "../../../../assets/images/SheetClose.svg";
import { Grid } from "@material-ui/core";

import PhoneInput from "react-phone-input-2";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function AddAddress(props) {
  const { close, cartId, recipients, id, itemDetails } = props;

  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const savedArea = useSelector((state) => state.area);
  const savedCity = useSelector((state) => state.city);
  const cityList = useSelector((state) => state.auth.cities);
  const areaList = useSelector((state) => state.auth.areas);

  console.log(savedArea, savedCity, "fdhggfsfsdfdshf")

  const [toast, setToast] = useState(false);
  const [Successtoast, setSuccessToast] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [successText, setSuccessText] = useState("");

  const [showRecipient, setShowRecipient] = useState(false);
  const [selectRecipient, setSelectRecipient] = useState([]);
  const [submitLabel, setSubmitLable] = useState("Add Address");
  const [mobileview, setMobileView] = useState(false);
  const [width, height] = useWindowSize();
  const cartState = useSelector((state) => state.cartsData);
  const [selectOptions, setSelectOptions] = useState([]);
  console.log(selectOptions, "selectOptions")
  const [selectedRecipientName, setSelectedRecipientName] = useState([]);

  const [nphone, setNphone] = useState();
  const [phoneError1, setPhoneError1] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [country, setCountry] = useState();

  const [countryDialCode, setCountryDialCode] = useState();




  const [city, setcity] = React.useState([]);
  const [area, setArea] = React.useState([]);

  const [areaList1, setAreaList1] = React.useState([]);

  const [cityValue2, setCityValue2] = React.useState();
  console.log(cityValue2, "gfhhhgfhf")
  const [arValue, setArValue] = React.useState();

  const [cityUuid, setCityUuid] = useState("")
  const [areaUuid, setAreaUuid] = useState("")


  useEffect(() => {
    let values = {
      label: savedCity && savedCity.label,
      name: '',
      value: savedCity && savedCity.value,
    };
    // setCityName(values)
    setCityValue2(values)
    setArValue(savedArea && savedArea.area && savedArea.area.label)
  }, [])



  const _onPhoneChange = (value, country, e, formattedValue) => {
    setNphone(value);
    setCountryDialCode(country.dialCode);
  };





  console.log(nphone);
  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((res) => {
        setCountry(res.country_code.toLowerCase());
        // setCountryCode(res.country_calling_code);
      })
      .catch((data, status) => {
        console.log("Request failed:", data);
      });
  }, []);

  useEffect(() => {
    if (width && width < 960) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  }, [width]);

  useEffect(() => {
    let data = [];
    recipients &&
      recipients.map((item) => {
        console.log(item, "item1111")
        data.push({ name: item.full_name, id: item.uuid, recipentData: item });
      });
    setSelectOptions(data);
  }, [recipients]);

  const [addressForm, setAddressForm] = useState({
    address: "",
    city: "",
    area: "",
    postCode: "",
    phone: "",
    email: "",
    recipient: "",
  });

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    setAddressForm((addressForm) => {
      addressForm[name] = value;
      return {
        ...addressForm,
      };
    });
  };

  useEffect(() => {
    if (id === 1) {
      setAddressForm({
        address: itemDetails.addressLine,
        city: "",
        area: "",
        postCode: itemDetails.pincode,
        phone: itemDetails.phoneNumber,
        // phone: nphone,
        email: itemDetails.email,
        recipient: "",
      });
      setSubmitLable("Update Address");
    }
  }, []);

  const handleAddAddress = async () => {
    let cityId = "";
    let areaid = "";

    cityList.map((item) => {
      if (item.name === savedCity.label) {
        cityId = item._id;
      }
    });

    areaList.map((item) => {
      if (item.name === savedArea.area.label) {
        areaid = item._id;
      }
    });

    if (addressForm.address === "") {
      setErrorText("Address Field Required");
      setToast(true);
      return false;
    }
    if (countryDialCode === "91" && nphone.length == 2) {
      setToast(true);
      setErrorText("mobile number Required");
      return false;
    }
    if (countryDialCode === "91" && nphone.length < 12) {
      setToast(true);
      setErrorText(
        "please enter valid 12 digit mobile number with country Code"
      );
      return false;
    }
    if (countryDialCode === "234" && nphone.length < 13) {
      setToast(true);
      setErrorText(
        "please enter valid mobile number with country Code"
      );
      return false;
    }
    if (nphone.length < 10) {
      setToast(true);
      setErrorText("please enter valid phone number");
      return false;
    }
    // if (addressForm.phone === "") {
    //   setErrorText("Phone Number Required");
    //   setToast(true);
    //   return false;
    // }

    // if (addressForm.postCode === "") {
    //   setErrorText("Post Code Required");
    //   setToast(true);
    //   return false;
    // }

    if (addressForm.email === "") {
      setErrorText("Email Required");
      setToast(true);
      return false;
    }

    let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (!emailRegex.test(addressForm.email)) {
      setErrorText("Enter valid Email Address");
      setToast(true);
      return false;
    }

    if (
      (id && id !== 1 && selectRecipient.length === 0) ||
      selectRecipient === null ||
      selectRecipient === undefined
    ) {
      setErrorText("Select Recipients");
      setToast(true);
      return false;
    }

    let addressData = [];
    selectRecipient &&
      selectRecipient.map((i) => {
        addressData.push(i);
      });

    let payLoad = {
      patient_uuid: addressData,
      addressLine: addressForm.address,
      // phoneNumber: addressForm.phone,
      phoneNumber: nphone,
      email: addressForm.email,
      pincode: addressForm.postCode,
      city: cityId,
      area: areaid,
      door_no: "Not Required",
      street: "Not Required",
      state: "Not Required",
      user_uuid: user.uuid,
    };

    let addressDataForEdit = {};
    try {
      addressDataForEdit = {
        // patient_uuid: itemDetails.patient_uuid,
        addressLine: addressForm.address,
        phoneNumber: addressForm.phone,
        email: addressForm.email,
        pincode: addressForm.postCode,
        city: cityId,
        area: areaid,
        door_no: "Not Required",
        street: "Not Required",
        state: "Not Required",
      };
    } catch (error) {
      console.log(error);
    }

    try {
      let response;
      if (id === 1) {
        response = await editAddress(
          itemDetails.patient_uuid,
          user.uuid,
          addressDataForEdit
        );
      } else {
        response = await addAddress(user.uuid, cartId, payLoad);
      }

      if (response.status === 201 || response.status === 200) {
        dispatch(getDeliveryAddress(user.uuid));
        setSuccessText("New Address Added Successfully");
        setSuccessToast(true);
        close();
      }
    } catch (error) {
      console.log(error);
    }
  };

  function handleRecipientChange(selectedList, selectedItem) {
    console.log(selectedList && selectedList[0].recipentData.mobile, "selectedList")
    setNphone(selectedList[0].recipentData.mobile)
    setAddressForm({ ...addressForm, email: selectedList[0].recipentData.email })
    try {
      let data = [];
      let names = [];
      selectedList.map((item) => {
        data.push(item.id);
        names.push(item.name);
      });
      setSelectRecipient(data);
    } catch (error) {
      console.log(error);
    }
  }

  const handleDeletion = (selectedList, removedItem) => {
    console.log(selectedList, removedItem);
    try {
      let data = [];
      let names = [];
      selectedList.map((item) => {
        data.push(item.id);
        names.push(item.name);
      });
      setSelectRecipient(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRecipient = (id, val) => {
    const idToRemove = id;
    if (selectRecipient.includes(val)) {
      const filteredPeople = selectRecipient.filter(
        (item) => item.uuid !== idToRemove
      );
      setSelectRecipient(filteredPeople);
    } else {
      setSelectRecipient([...selectRecipient, val]);
    }
  };






  React.useEffect(() => {
    if (cityList) {
      let res = cityList.map((e, i) => {

        return {
          label: e.name, value: e.uuid,
        };
      });
      setcity(res);
    }
  }, [cityList]);

  const handlearea = (e, city) => {
    // setAreaVal(city)
    setArValue('Select Area');
    setCityValue2(city)
    console.log(city, "sdassdfdsa")
    const { value, label, name } = city;
    console.log(value, label, name, "dsfasf")
    setCityUuid(value)
    dispatch(cityValue({ value, label }));
    axios
      .get(`${process.env.REACT_APP_API_URL}/uploadDoc/getArea/${value}`)
      .then((res) => setAreaList1(res.data));
  };

  React.useEffect(() => {
    if (areaList1 && areaList1.length !== 0) {
      let res = areaList1.map((e, i) => {
        return { label: e.name, value: e.uuid };
      });
      setArea(res);
    }
  }, [areaList1]);



  const handleselectedArea = (ev, selectedArea) => {
    console.log(selectedArea, "selectedCity")
    setArValue(selectedArea);
    setAreaUuid(selectedArea);
    dispatch(areaValue(selectedArea));
  }
  return (
    <>
      <div className="parentContainer"
      // style={{padding:"0% 0% 8% 8%"}}
      >
        <Grid align="right">
          <img src={Closeicon} alt="close icon" style={{ paddingBottom: "10px", width: "40px",cursor:"pointer" }}
            // onClick={()=>setAddRelative(false)}
            onClick={close}

          />
        </Grid>
        <Form>
          <div className="secondary_input">
            <div className="sub-header-text mt-3">
              WHO IS THE SAMPLE COLLECTION FOR?
            </div>

            {/* DropDown start */}

            {id !== 1 && (
              <div className="recipient" style={{ width: "95%" }}>
                <Multiselect
                  // ref={focusPoint}
                  options={selectOptions && selectOptions}
                  // selectedValues={selectedRecipientName && selectedRecipientName}
                  onSelect={handleRecipientChange}
                  onRemove={handleDeletion}
                  displayValue="name"
                  showCheckbox={true}
                  placeholder={`Select Recipient`}
                  showArrow={true}
                  style={{
                    inputField: {
                      // To change input field position or margin
                      margin: "5px",
                    },
                    chips: {
                      // To change css chips(Selected options)
                      background: "#F7F8FB",
                      color: "black",
                    },
                    searchBox: {
                      // To change search box element look
                      color: "black",
                    },
                    optionContainer: {
                      // To change css for option container
                      border: "1px solid #E3EAF6",
                    },
                    option: {
                      // To change css for dropdown options
                      border: "1px solid #E3EAF6",
                      background: "transparent",
                      color: "#191716",
                      margin: "10px",
                    },
                  }}
                />
              </div>
            )}

            {/* New Dropdown */}

            {id == 1 && (
              <div className="sub-header-text mt-3">
                {itemDetails && itemDetails.patientName}
              </div>
            )}
          </div>
          <div className="mb-1 form-align" >

            <Form.Group as={Col} className="mb-1" controlId="formGridAddress1">
              <Form.Label>City</Form.Label>
              {/* <Form.Control
                name="city"
                placeholder="Enter City"
                readOnly
                value={savedCity && savedCity.label}
              /> */}
              {/* 
              <DropDown
                        placeholder={"Select City"}
                        value={cityValue2}
                        onChange={(e) => {
                          handlearea(e.target);
                          setArValue('Select Area');
                          console.log(e, "adasdasdasd")
                        }}

                        options={city && city.length !== 0 ? city : []}
                        // options={city}
                        className="recipient"
                      
                        // style={{background:"#fff", color:"red"}}
                      /> */}

              <Autocomplete
                // style={{ width: "95%" }}
                className="autocomplete1"
                value={cityValue2 ? cityValue2 : null}
                id="grouped-demo"
                options={city}
                // getOptionLabel={(option) => option.label}
                sx={{ width: 300 }}
                renderInput={(params) => <TextField {...params}
                  placeholder={"Select City"}
                />
                }
                onChange={handlearea}

              />

            </Form.Group>



            <Form.Group as={Col} className="mb-1" controlId="formGridCity" >
              <Form.Label>Area</Form.Label>
              {/* <Form.Control
                name="area"
                placeholder="Enter Area"
                readOnly
                value={savedArea && savedArea.area && savedArea.area.label}
              /> */}

              {/* 
              <DropDown
                        placeholder={"Select Area"}
                        onChange={(e) => {
                          setArValue(e.target);
                          setAreaUuid(e.target.value);
                          dispatch(areaValue(e.target));
                          // props.handleLocationChange();
                        }}
                        value={arValue}
                        // defaultValue={arValue}
                        // setValue={(value) => console.log(value)}
                        options={area && area.length !== 0 ? area : []}
                        // className="input"
                      /> */}
              <Autocomplete
                // style={{ width: "95%" }}
                className="autocomplete1"
                value={arValue ? arValue : null}
                id="grouped-demo"
                options={area && area.length !== 0 ? area : []}
                // getOptionLabel={(option) => option.label}
                sx={{ width: 300 }}
                renderInput={(params) => <TextField {...params}
                  placeholder={"Select City"}
                  
                />
                }
                onChange={handleselectedArea}

              />
            </Form.Group>
          </div>

          <div className="mb-1 form-align">
            <Form.Group as={Col} className="mb-1" controlId="formGridCity">
              <Form.Label>Address</Form.Label>
              <Form.Control
                name="address"
                placeholder="Address"
                onChange={(event) => handleInputChange(event)}
                defaultValue={addressForm.address}
              />
            </Form.Group>

            {/* <Form.Group as={Col} controlId="formGridPassword">
              <Form.Label>Postcode </Form.Label>
              <Form.Control
                name="postCode"
                type="number"
                placeholder="Enter postcode"
                onChange={(event) => handleInputChange(event)}
                defaultValue={addressForm.postCode}
              />
            </Form.Group> */}
            {/* </div> */}

            {/* <div className="mb-1 form-align"> */}
            <Form.Group as={Col} controlId="formGridPassword">
              <Form.Label>Phone Number</Form.Label>
              {/* <Form.Control
                name="phone"
                type="number"
                placeholder="Enter Phone No."
                onChange={(event) => handleInputChange(event)}
                // data-id={index}
                defaultValue={addressForm.phone}
              /> */}
              <div>
                <PhoneInput
                  isValid={(value) => {
                    if (value.toString().startsWith("234") ? value.length <= 12 : value.length < 12 || value.length > 15) {
                      if (value.length >= 4 && value.length <= 12)
                        setPhoneError1(true);
                      return false;
                    } else {
                      setPhoneError1(false);
                      return true;
                    }
                  }}
                  containerClass=""
                  country={country}
                  value={nphone}
                  onChange={(value, country, e, formattedValue) =>
                    _onPhoneChange(value, country, e, formattedValue)
                  }
                  maxLength={10}
                />
                {phoneError ? <>Phone is Required</> : null}
                <p className="errorFont">
                        {phoneError1 ? (
                          <>Please Enter Valid Phone Number</>
                        ) : null}
                      </p>
                {/* <p className="errorFont">
                  {phoneError ? (
                    <>Phone is Required</>
                  ) : null}
                </p>
                <p className="errorFont">
                  {phoneError1 ? (
                    <>Please Enter Valid Phone Number</>
                  ) : null}
                </p> */}
              </div>
            </Form.Group>


            {/* </div> */}
          </div>
          <Form.Group as={Col} controlId="formGridEmail">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              name="email"
              type="email"
              placeholder="Enter email"
              onChange={(event) => handleInputChange(event)}
              defaultValue={addressForm.email}
            />
          </Form.Group>











          {/* <div className="form-container-out"> */}


            <div className="btn_grp"
            // className="form-group row" style={{display:"flex",justifyContent:"center",alignItems:"Center"}}
            > 
              <div >
                <Button
                className="addrelativ-btn1"
                  // style={{
                  //   backgroundColor: "#FF5C3C",
                  //   width: "150px",
                  //   height: "auto",
                  //   borderColor: "#FF5C3C",
                  //   marginTop: "10px",
                  // }}
                  onClick={handleAddAddress}
                >
                  {submitLabel}
                </Button>
              </div>
              <div >
                <Button
                className="addrelativ-btn2"
                  // style={{
                  //   backgroundColor: "#FF5C3C",
                  //   width: "150px",
                  //   height: "auto",
                  //   borderColor: "#FF5C3C",
                  //   marginTop: "10px",
                  // }}
                  onClick={close}
                >
                  Close
                </Button>
              </div>
            </div>
          {/* </div> */}
          <Toast
            text={errorText}
            type="error"
            open={toast}
            setClose={() => {
              setToast(false);
            }}
          />
          <Toast
            text={successText}
            type="success"
            open={Successtoast}
            setClose={() => {
              setSuccessToast(false);
            }}
          />
        </Form>
      </div>
    </>
  );
}
